(function() {
    'use strict';

    angular
        .module('atheer.user')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('storm.admin-user-invitation', {
            url: '/users/invitations?page&sort&search',
            templateUrl: 'modules/user/invitation/user-invitations.html',
            controller: 'UserInvitationController',
            controllerAs: 'vm',
            data: {
                pageTitle: 'atheer.userInvitation.home.title',
                layout: {
                    contentClass: 'layout-column',
                    footer: false,
                    showToolbar: false
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        });
    }
})();
